/**
 * The classic Warcraft Logs percentile palette: grey/green/blue/purple/
 * orange/pink/gold, in ascending order of rarity. `null` (no data) gets its
 * own neutral grey, visually distinct from a genuine 0th-percentile parse.
 */
export function parseColor(percent) {
    if (percent === null)
        return '#6b7280';
    if (percent >= 100)
        return '#e5cc80';
    if (percent >= 99)
        return '#e268a8';
    if (percent >= 95)
        return '#ff8000';
    if (percent >= 75)
        return '#a335ee';
    if (percent >= 50)
        return '#0070dd';
    if (percent >= 25)
        return '#1eff00';
    return '#666666';
}
/** Mythic beats Heroic beats Normal — the order raid difficulties rank by prestige. */
const DIFFICULTY_RANK = ['mythic', 'heroic', 'normal'];
/**
 * Picks the single most impressive difficulty a character has parses for
 * (Mythic if any, else Heroic, else Normal) — what a roster overview
 * headlines rather than showing three separate numbers per character.
 */
export function bestRaidParseSummary(summaries) {
    if (!summaries || summaries.length === 0)
        return null;
    for (const difficulty of DIFFICULTY_RANK) {
        const match = summaries.find((summary) => summary.difficulty === difficulty);
        if (match)
            return match;
    }
    return summaries[0] ?? null;
}
/**
 * The one number a headline summary shows for a raid difficulty: Warcraft
 * Logs' own "Best Perf. Average" — its own character page's headline
 * number — falling back to the median only on the rare response that has
 * one but not the other.
 */
export function bestAvailableParsePercent(summary) {
    if (!summary)
        return null;
    return summary.overallBestPercent ?? summary.overallMedianPercent ?? null;
}
//# sourceMappingURL=parses.js.map